import React from "react";
import LegalLayout from "./LegalLayout";

const GrievanceRedressalPolicy = () => (
  <LegalLayout
    title="Grievance Redressal Policy"
    subtitle="Pawansut Holdings Limited — We are here to listen"
  >
    <p className="last-updated">Last updated: February 2025</p>
    <p className="intro">
      Pawansut Holdings Limited is committed to addressing customer complaints
      in a fair and timely manner. This Grievance Redressal Policy outlines how
      you can lodge a complaint, the process we follow, and the timelines for
      resolution, in line with RBI guidelines for NBFCs.
    </p>

    <section>
      <h2>1. Scope</h2>
      <p>
        This policy applies to complaints related to our products and services,
        including but not limited to loan disbursement, interest or charges,
        statements, recovery practices, service quality, and any other
        grievance arising from your dealings with the Company.
      </p>
    </section>

    <section>
      <h2>2. How to Lodge a Complaint</h2>
      <p>You may register your grievance through any of the following:</p>
      <ul>
        <li><strong>Email:</strong> grievance@pawansut.com (or the email id displayed on our website)</li>
        <li><strong>Post:</strong> Write to our Grievance Redressal Officer at our registered office address</li>
        <li><strong>Website:</strong> Use the &quot;Contact Us&quot; or &quot;Grievance&quot; section and submit the complaint form</li>
        <li><strong>Phone:</strong> Call our designated grievance helpline during business hours</li>
      </ul>
      <p>
        Please provide your name, contact details, loan/account reference (if
        any), and a clear description of the complaint with supporting
        documents where relevant.
      </p>
    </section>

    <section>
      <h2>3. Grievance Redressal Officer</h2>
      <p>
        We have designated a Grievance Redressal Officer (&quot;GRO&quot;) responsible
        for receiving, tracking, and resolving complaints. The name, contact
        details, and address of the GRO are displayed on our website and in our
        branch/office. You may request this information from any of our customer
        touchpoints.
      </p>
    </section>

    <section>
      <h2>4. Acknowledgement and Resolution</h2>
      <ul>
        <li>We acknowledge your complaint within a few working days of receipt.</li>
        <li>We endeavour to resolve complaints within 30 days from the date of receipt, or as per the timeline prescribed by RBI from time to time.</li>
        <li>If the issue is complex and requires more time, we will inform you of the extended timeline and the reason.</li>
        <li>Once resolved, we will communicate the outcome to you in writing or through your preferred channel.</li>
      </ul>
    </section>

    <section>
      <h2>5. Escalation</h2>
      <p>
        If you are not satisfied with our response or if we do not resolve your
        complaint within the stated period, you may escalate to the Reserve Bank
        of India – Integrated Ombudsman Scheme (RB-IOS) or the appropriate
        RBI mechanism as applicable to NBFCs. We will provide the necessary
        escalation details in our final response.
      </p>
    </section>

    <section>
      <h2>6. No Discrimination</h2>
      <p>
        Lodging a complaint will not affect your existing relationship with us
        or your eligibility for future products. We do not discriminate against
        customers who exercise their right to complain.
      </p>
    </section>

    <section>
      <h2>7. Record Keeping</h2>
      <p>
        We maintain records of complaints and their resolution for the periods
        required under regulatory guidelines, for audit and improvement
        purposes.
      </p>
    </section>

    <section>
      <h2>8. Review of Policy</h2>
      <p>
        This policy is reviewed periodically and updated to align with RBI
        guidelines and our commitment to customer satisfaction. The updated
        policy will be published on our website.
      </p>
    </section>

    <section>
      <h2>9. Contact</h2>
      <p>
        For any query regarding this policy or to lodge a complaint, please
        refer to the &quot;Contact Us&quot; section on our website or get in touch with
        our Grievance Redressal Officer at the address and contact details
        provided there.
      </p>
    </section>
  </LegalLayout>
);

export default GrievanceRedressalPolicy;
